import { Button, Flex, Typography } from "antd"

const { Text } = Typography

export const ErrorFallback = ({ resetError, error }) => {
  return (
    <Flex vertical gap={16} align="center" justify="center" style={{ height: "100vh" }}>
      <Text>
        Oops, something went wrong! <strong>{String(error)}</strong>
      </Text>
      <Button onClick={resetError}>Retry</Button>
    </Flex>
  )
}
